import React from 'react';
import { Button } from '..';

function DeleteButton(props) {
  const { style, title = 'Eliminar', icon = true, ...rest } = props;

  return (
    <Button
      link
      style={{ color: 'var(--input-error-color)', ...style }}
      {...rest}
    >
      {icon && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ marginTop: 2 }}
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      )}
      <span>{title}</span>
    </Button>
  );
}

export default DeleteButton;
